import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL BRANDS
export const brandList = (params = '') => Http.get(`/brands${serialize(params)}`)
export const brandCreate = (params = '') => Http.post('/brands', params)
export const brandByID = (params = '') => Http.get(`/brands/${params}`)
export const brandUpdate = (params = '') => Http.put(`/brands/${params.id}`, params)
export const brandDestroy = (params = '') => Http.delete(`/brands/${params.id}`)
